import { addDays } from 'date-fns';
import { Maybe, fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { L, T } from '../../../../../../../Translations';
import { ScheduledProgramInstanceOption } from '../../../../../Types';
import { SelectingDate } from '../Types';
import Form, { selectable } from './Form';
import Submit from './Submit';

export interface Actions {
  inviting: (programIds: number[]) => void;
  selectDate: (programId: number) => void;
  back: () => void;
}

export interface Props {
  state: SelectingDate;
  actions: Actions;
}

const availableOptions = (
  scheduledOptions: ScheduledProgramInstanceOption[],
  daysUntilRenewal: number,
): Maybe<ScheduledProgramInstanceOption[]> =>
  fromEmpty(scheduledOptions.filter((o) => selectable(o, daysUntilRenewal)));

function SelectDateModal({ actions, state }: Props) {
  const { shareUrl, daysUntilRenewal, programIds } = state;
  return availableOptions(
    shareUrl.shareUrl.payload.programInstanceOptions.scheduled,
    daysUntilRenewal,
  )
    .map(() => (
      <>
        <p className="mt-4 font-semibold">
          <T kind="Choose Start Date" />
        </p>
        <p className="mt-2 text-sm">
          <T
            kind="<span>{{name}}</span> is a faculty-led program offered with the following start dates..."
            name={shareUrl.name.text}
            span={(content) => <span className="font-bold">{content}</span>}
          />
        </p>
        <Form
          state={state}
          actions={{ inviting: actions.inviting, selectDate: actions.selectDate }}
        />
        <Submit
          actions={{ inviting: actions.inviting, back: actions.back }}
          selectedPrograms={programIds}
        />
      </>
    ))
    .getOrElse(() => (
      <div className="my-4">
        <p className="mb-4">
          <T
            kind="The upcoming faculty-led dates for {{name}} are outside of the license period..."
            name={shareUrl.name.text}
            expiration={
              <L
                localizeable={addDays(new Date(), daysUntilRenewal)}
                format="short-month-day-year"
              />
            }
          />
        </p>
        <p>
          <T kind="Update the license associated with this learning collection to see new available dates..." />
        </p>
      </div>
    ));
}
export default observer(SelectDateModal);
